<template>
  <div>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-chip
          class="data-chip"
          color="blue-grey darken-1"
          text-color="white"
          selected
          v-on="on"
        >
          <span :class="{ 'clip-text' : overflow }">
            {{ dataString }}
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyDataString"
          >
            content_copy
          </v-icon>
        </v-chip>
      </template>
      {{ getTooltipText() }}
    </v-tooltip>
    <v-snackbar
      v-model="snackbar"
      bottom="bottom"
      :timeout="timeout"
      color="blue-grey"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

export default {
  name: 'DataChip',
  props: {
    data: {
      type: String,
      default: null,
      required: true,
    },
    overflow: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      dataString: null,
      loading: false,
      snackbar: false,
      snackbarText: '',
      timeout: 2000,
    };
  },
  mounted() {
    this.dataString = this.data;
  },
  methods: {
    async copyDataString() {
      await navigator.clipboard.writeText(this.dataString);
      this.snackbarText = `"${this.dataString}" copied to clipboard.`;
      this.snackbar = true;
    },
    getTooltipText() {
      return this.tooltipText ? this.tooltipText : 'Copy Data';
    },
  },
};
</script>

<style lang='scss' scoped>
  .clip-text {
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/DataChip.vue